import React, { useState } from 'react';
import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableHead,
  Collapse,
  IconButton,
  Grid,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LinkIcon from '@material-ui/icons/Link';
import PropTypes from 'prop-types';
import {
  StyledTableCell,
  StyledTableHeadCell,
} from '../../customUI/table/TableStyles';
import useStyles from './SearchIntelligence.style';

const AirtableRow = ({orderRow}) => {
  const classes = useStyles();
  
  const [open, setOpen] = useState(false);
  const row = orderRow.filter(obj => 'Tittle' in obj)[0];
  const placements = orderRow.filter(obj => !('Tittle' in obj));

  const handleRowClick = () => {
    setOpen(!open);
  }

  const capitalization = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  return (
    <>
        <TableRow key={row["Order ID"]} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)'}}>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(0, 180, 224, 0.1)'}}>
              <Box display="flex" flexDirection="row" style={{ textTransform: "capitalize"}}>
                <IconButton
                    aria-label="expand row"
                    className={classes.arrowButton}
                    onClick={handleRowClick}
                >
                    {open ? (
                    <KeyboardArrowUpIcon style={{ fontSize: 'medium' }} />
                    ) : (
                    <KeyboardArrowDownIcon style={{ fontSize: 'medium' }} />
                    )}
                </IconButton>
                {row["Task Started"] && !Number.isNaN(new Date(row["Task Started"]).getTime()) ? `${new Date(row["Task Started"]).toLocaleString('en-US', {
                    year: 'numeric',
                })}` : "-"}
              </Box>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(0, 180, 224, 0.1)'}}>
              {row["Task Started"] && !Number.isNaN(new Date(row["Task Started"]).getTime()) ? `${new Date(row["Task Started"]).toLocaleString('en-US', {
                  month: 'short',
              })}` : "-"}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" style={{ background: 'rgba(214, 255, 212, 0.3)'}}>
              {row.Tittle? capitalization(row.Tittle): "-"}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row">
              {row["Task Started"] && !Number.isNaN(new Date(row["Task Started"]).getTime()) ? `${new Date(row["Task Started"]).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
              })}` : "-"}
            </StyledTableCell>
            <StyledTableCell>
              {row.Status}
            </StyledTableCell>
        </TableRow>
        <TableRow>
            <StyledTableCell style={{ padding: 0 }} colSpan={8}>
              <Collapse 
                in={open}
                timeout="auto"
                unmountOnExit
                style={{
                  display: "block",
                  justifyContent: "center",
                  flex: 1,
                  width: "100%",
                }}
              >
                <Table>
                  <TableHead>
                      <TableRow style={{ padding: 10, background: '#f5f3f3'}}>
                          <StyledTableHeadCell style={{ position: 'relative', width: '120px', minWidth: '120px', background: '#f5f3f3' }}>
                              <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                  Date
                              </Box>
                          </StyledTableHeadCell>
                          <StyledTableHeadCell style={{ position: 'relative', minWidth: '90px', background: '#f5f3f3' }} >
                              <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                  Domain Rank
                              </Box>
                          </StyledTableHeadCell>
                          <StyledTableHeadCell style={{ position: 'relative', maxWidth: '500px', background: '#f5f3f3' }}>
                              <Box display='flex' flex={1} justifyContent='space-between'>
                                  Link URL
                              </Box>
                          </StyledTableHeadCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                    {placements.map((placement) => (
                      <TableRow key={placement.link} style={{ padding: 10, overflow: "hidden", borderBottom: '1px solid #f5f3f3'}}>
                        <StyledTableCell component="th" scope="row" style={!Number.isNaN(new Date(placement.date).getTime())? { width: '120px', minWidth: '120px' }: { width: '120px', minWidth: '120px', textAlign: 'center' }} >
                          <Grid item xs={4} style={{ color:"grey", minWidth: '100px'}}> 
                            <span>
                              {`${ !Number.isNaN(new Date(placement["Task Started"]).getTime())? new Date(placement["Task Started"]).toLocaleString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                              }):
                              "--"}`}
                            </span>
                          </Grid>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row" style={{ width: '90px', minWidth: '90px'  }} >
                          <Grid style={{color:"grey"}} item xs={4}>
                            <span>{placement.DR || "-"}</span>
                          </Grid>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row" >
                          <Grid spacing={3}>
                            <div style={{ 
                              display: "flex", 
                              gap: '10px', 
                              color: '#00B5E2',
                              width: '100%',
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}>
                              <LinkIcon style={{ width: "14px"}} />
                              <a 
                                href={placement.URL} 
                                style={{ 
                                  textDecoration: 'none',
                                }} 
                                target="_blank"
                                rel="noreferrer">
                                <div className={classes.prLink}>
                                  {placement.URL}
                                </div>
                              </a>
                            </div>
                          </Grid>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Collapse>
            </StyledTableCell>
        </TableRow>
    </>
  );
};

AirtableRow.propTypes = {
  orderRow: PropTypes.arrayOf(PropTypes.obj),
};

AirtableRow.defaultProps = {
  orderRow: [],
};

export default AirtableRow;
